import { createSelector } from "@reduxjs/toolkit";

export const FULL_SCREEN_STATE_ROOT_SELECTOR = state => state.fullScreenSlice;
export const CREATE_FULL_SCREEN_SELECTOR = (s) => createSelector(FULL_SCREEN_STATE_ROOT_SELECTOR, s);

export const FULL_SCREEN_COMPONENT_TYPES = {
  STUDIO: "studio",
};
